import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {isEmpty, omit} from 'underscore';

import {fetchMe} from 'common/actions/user';
import {getFetching, getRideRequest} from 'ondemand/selectors';
import Navigation from 'ondemand/components/Navigation';
import FloatingBarLayout from 'ondemand/components/FloatingBarLayout';
import ResponsiveDrawerLayout from 'ondemand/components/ResponsiveDrawerLayout';
import AlertStack from 'ondemand/containers/AlertStack';
import HashParser from 'ondemand/containers/HashParser';
import PrivacyPolicyGuard from 'ondemand/containers/PrivacyPolicyGuard';
import queryString from 'query-string';

import {Route, Switch} from 'react-router-dom';

import AddressesPage from 'ondemand/containers/AddressesPage';
import AddressEditor from 'ondemand/containers/AddressEditor';
import BookARide from 'ondemand/containers/BookARide';
import RidePage from 'ondemand/containers/RidePage';
import MyRidesPage from 'ondemand/containers/MyRidesPage';
import RideRequestPage from 'ondemand/containers/RideRequestPage';
import AgencyPage from 'ondemand/containers/AgencyPage';

import {ThemeProvider as MuiThemeProvider} from '@material-ui/core/styles';
import {createMuiTheme} from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#468EE5', // TODO(bblackwood): pull from transloc colors
    },
  },
});


class App extends React.Component {

  static displayName = 'App';

  static propTypes = {
    fetching: PropTypes.object,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    rideRequest: PropTypes.object,
    user: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.dispatch(fetchMe());
  }

  render() {
    const showMenu = !!queryString.parse(this.props.location.search).showMenu;
    const drawerContent = <Navigation user={this.props.user} />;

    const loadingScreen = document.getElementById('loading-screen');
    if (loadingScreen) {
      if (isEmpty(omit(this.props.fetching, 'rideDetails', 'serviceEstimate', 'vehiclePosition'))) {
        loadingScreen.style.visibility = 'hidden';
      } else {
        loadingScreen.style.visibility = 'visible';
      }
    }

    return (
      <div style={{height: '100%'}}>
        <MuiThemeProvider theme={theme}>
          <HashParser location={this.props.location} />
          <FloatingBarLayout
            desktopMax={400}
            mobileMax={756}
            leftOffset={220}
            barContent={<AlertStack />}
          >
            <ResponsiveDrawerLayout
              drawerContent={drawerContent}
              hideHamburger={this.props.rideRequest.pickup !== null}
              mobileMax={756}
              open={showMenu}
            >
              <div style={{height: '100%'}}>
                <PrivacyPolicyGuard>
                  <Switch>
                    <Route exact path="/" component={RideRequestPage} />
                    <Route path="/book" component={BookARide} />
                    <Route path="/agency" component={AgencyPage} />
                    <Route exact path="/rides" component={MyRidesPage} />
                    <Route path="/rides/:rideId" component={RidePage} />
                    <Route exact path="/addresses" component={AddressesPage} />
                    <Route path="/addresses/new" component={AddressEditor} />
                    <Route path="/addresses/edit/:addressId" component={AddressEditor} />
                  </Switch>
                </PrivacyPolicyGuard>
              </div>
            </ResponsiveDrawerLayout>
          </FloatingBarLayout>
        </MuiThemeProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fetching: getFetching(state),
  rideRequest: getRideRequest(state),
  user: state.user.user || {},
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/ondemand/containers/App.js